export const trimAndTruncateString = (text: string, length: number) =>
  text.length > length ? `${text.substring(0, length)}...` : text;

export const streamingText = (current: string, addition: string) => `${current.replace('●', '')}${addition} ●`;
